import { Skeleton } from "@mui/material";
import "./Skeleton.css";
const ListLoader = ({ count }) => {
  // Convert to number to ensure the array length is correct
  const safeCount = Number(count);

  return (
    <div className="list">
      {[...Array(safeCount)].map((_, i) => (
        <div className="item" key={i}>
          <div className="child">
            <Skeleton />
          </div>
          <div className="child">
            <Skeleton variant="circular" width={30} height={30} />
          </div>
        </div>
      ))}
    </div>
  );
};
export default ListLoader;
